export default __webpack_public_path__ + "static/media/Logo-Type.7da49858.png";